package tables.user

import emotion.react.css
import entities.User
import kotlinx.browser.window
import kotlinx.datetime.internal.JSJoda.LocalDateTime
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.table
import react.dom.html.ReactHTML.tbody
import react.dom.html.ReactHTML.td
import react.dom.html.ReactHTML.th
import react.dom.html.ReactHTML.thead
import react.dom.html.ReactHTML.tr
import react.useEffect
import react.useState
import token
import urlAddress
import web.cssom.BorderCollapse
import web.cssom.Color
import web.cssom.TextAlign

external interface UserProps : Props

val UserTable = FC<UserProps> {
    val (users, setUsers) = useState(emptyList<User>())

    fun loadUsers() {
        window.fetch(urlAddress + "api/user", RequestInit(
            method = "GET",
            headers = Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    User(
                        it.id as? Int ?: 0,
                        it.firstName as? String ?: "",
                        it.lastName as? String ?: "",
                        it.telegramName as? String ?: "",
                        it.dateReg as? String ?: "",
                        it.phone as? String ?: "",
                        it.telegramId,
                        it.role as? String ?: ""
                    )
                }
                setUsers(newResultList)
            }
            .catch { error ->
                console.error("Fetch error:", error)
            }
    }

    useEffect(users.isEmpty()) {
        loadUsers()
    }

    div {
        table {
            border = 1
            css {
                borderColor = Color("#000")
                borderCollapse = BorderCollapse.collapse
                textAlign = TextAlign.center
            }
            thead {
                tr {
                    th { +"ID" }
                    th { +"Имя" }
                    th { +"Фамилия" }
                    th { +"Username" }
                    th { +"Телефон" }
                    th { +"Телеграмм ID" }
                    th { +"Роль" }
                    th { +"Зарегистрирован" }
                }
            }
            tbody {
                users.map { item ->
                    tr {
                        td { +"${item.id}" }
                        td { +(item.firstName) }
                        td { +(item.lastName) }
                        td { +(item.telegramName) }
                        td { +(item.phone) }
                        td { +"${item.telegramId}" }
                        td { +item.role }
                        td { +"${LocalDateTime.parse(item.dateReg).toLocalDate()}" }
                    }
                }
            }
        }
    }

}

